"use client";

import { usePriceFormatter } from "@/lib/hooks/use-price-formatter";
import { processMockCheckoutSession } from "@/lib/mock/actions";
import { Button } from "@/components/catalyst/button";
import { Creator, Product } from "@/lib/entities";
import { useState } from "react";

type MockCheckoutFormProps = {
  product: Product;
  creator: Creator;
  datetime?: number;
  disabled?: boolean;
};

export function MockCheckoutForm({
  product,
  creator,
  datetime,
  disabled,
}: MockCheckoutFormProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const formatPrice = usePriceFormatter();

  const handlePay = async () => {
    setIsLoading(true);

    const result = await processMockCheckoutSession(
      product,
      creator.slug,
      datetime,
    );

    if (result?.error) {
      setError(result.error);
    }

    setIsLoading(false);
  };

  const formattedPrice = formatPrice(product.price, product.currency);

  return (
    <div className="space-y-6">
      <div className="rounded-md border border-yellow-200 bg-yellow-50 p-4">
        <p className="text-sm text-yellow-800">
          ⚠️ You are in mock checkout mode. No real payment will be processed.
        </p>
      </div>

      {error && (
        <div className="rounded-md border border-red-200 bg-red-50 p-4">
          <p className="text-sm text-red-800">{error}</p>
        </div>
      )}

      <div className="pt-4">
        <Button
          onClick={handlePay}
          disabled={disabled || isLoading}
          className="w-full"
          color="purple"
          data-testid="checkout-pay-button"
        >
          {isLoading ? "Processing Payment..." : `Pay ${formattedPrice}`}
        </Button>
      </div>
    </div>
  );
}
